
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.355 0a.871.871 0 00-.871.871v1.932H2.032C.936 2.803 0 3.688 0 4.795v11.214C0 17.115.936 18 2.032 18h13.936C17.064 18 18 17.115 18 16.009V4.795c0-1.107-.936-1.992-2.032-1.992h-1.452V.871a.871.871 0 00-.87-.871.871.871 0 00-.872.871v1.932H5.226V.871A.871.871 0 004.355 0zM2.032 4.545h1.452v1.933a.871.871 0 00.87.87.871.871 0 00.872-.87V4.545h7.548v1.933a.871.871 0 00.871.87.871.871 0 00.871-.87V4.545h1.452c.187 0 .29.118.29.25v11.214c0 .131-.103.25-.29.25H2.032c-.187 0-.29-.119-.29-.25V4.795c0-.132.103-.25.29-.25zm4.652 3.003a.871.871 0 00-.624.254.871.871 0 000 1.234l1.706 1.706-1.706 1.706a.871.871 0 000 1.233.871.871 0 001.234 0L9 11.976l1.706 1.705a.871.871 0 001.234 0 .871.871 0 000-1.233l-1.706-1.706 1.706-1.706a.871.871 0 000-1.234.871.871 0 00-1.234 0L9 9.508 7.294 7.802a.871.871 0 00-.61-.254z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    